import { Clock3Icon, StarIcon } from "@/shared/icons";
import FactionImprovementsLevel from "@/domains/faction/components/FactionImprovementsLevel";

export default function FactionImprovementInfo() {
  return (
    <div
      className="absolute z-2 top-50% left-50% w-[19.375rem] h-auto p-5 rounded-2xl"
      style={{
        background:
          "linear-gradient(312deg, rgba(255, 255, 255, 0.00) 45.73%, rgba(255, 255, 255, 0.01) 83.66%, rgba(255, 255, 255, 0.06) 100%), #181818",
      }}
    >
      <div className="mb-2 text-15 font-extrabold leading-none uppercase">Улучшенный гараж</div>
      <div className="mb-7 text-12 font-medium text-white/70">
        Данное улучшение позволяет дополнительно к уже имеющимся местам в гараже, добавить новые
      </div>
      <div className="flex flex-col gap-2.5">
        <FactionImprovementsLevel
          level={1}
          text="Дополнительное место в гараже фракции увеличено на +1"
          isActive
        />
        <FactionImprovementsLevel
          level={2}
          text="Дополнительное место в гараже фракции увеличено на +2"
        />
        <FactionImprovementsLevel
          level={3}
          text="Дополнительное место в гараже фракции увеличено на +3"
        />
      </div>
      <div className="mt-7.5 mb-3">
        <div className="flex items-center mb-2">
          <Clock3Icon className="size-4 text-[#B8B8B8]" />
          <div className="ml-1.5 text-13 font-medium text-white/70 leading-none">
            Время изучения:
          </div>
          <div className="ml-auto text-13 font-bold leading-none uppercase">3д. 12ч.</div>
        </div>
        <div className="flex items-center">
          <StarIcon className="size-4 text-[#B8B8B8]" />
          <div className="ml-1.5 text-13 font-medium text-white/70 leading-none">
            Требуется баллов:
          </div>
          <div className="ml-auto text-13 font-bold leading-none uppercase">3</div>
        </div>
      </div>
      <button
        type="button"
        className="flex justify-center items-center w-full h-12 bg-white/3 text-12 font-bold uppercase rounded-xl transition-all duration-200 hover:bg-accent-muted"
      >
        Изучить
      </button>
    </div>
  );
}
